import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './locales/en';

const translations = {
  en: en,
};

// see more on https://react.i18next.com/
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: translations,
    lng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
